import {checkPayment} from "@/api/invoice";

export default {
  watch: {
    orderId: {
      immediate: true,
      handler(id) {
        if (!id) return;

        this.$broadcastClient
          .private(`orders.${id}`)
          .listen('.InvoicePaid', (e) => {
            this.checkPaid(e.invoiceId);
          });
      }
    }
  },

  beforeDestroy() {
    if (this.orderId) {
      this.$broadcastClient.leave(`orders.${this.orderId}`);
    }
  }
}
